import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import {
	CommitteeMember,
	CommitteeMemberListResponse,
	CreateCommitteeMemberPayload,
	UpdateCommitteeMemberPayload,
	AttachMemberPayload,
} from '../models/members';
import { BoardMember } from '../../boards/models/members';

export const onGetCommitteeMembers = async (committeeId: string, page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeMemberListResponse>>(
			`dashboard/committees/${committeeId}/members`,
			{
				params: { page },
			}
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeMemberById = async (committeeId: string, memberId: string) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeMember>>(
			`dashboard/committees/${committeeId}/members/${memberId}`
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeMemberByNationalId = async (nationalId: string) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeMember & { can_edit: boolean }>>(
			`dashboard/members/find-by-national-id?national_id=${nationalId}`,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddMemberToCommittee = async (committeeId: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<CommitteeMember>>(`dashboard/committees/${committeeId}/members`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onEditMemberFromCommittee = async (committeeId: string, memberId: number, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<CommitteeMember>>(`dashboard/committees/${committeeId}/members/${memberId}`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteMemberFromCommittee = async (committeeId: string, memberId: number) => {
	try {
		const response = await axios.delete<JsonResponse<CommitteeMember>>(`dashboard/committees/${committeeId}/members/${memberId}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateCommitteeSecretary = async (committeeId: number, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<CommitteeMember>>(`dashboard/committees/${committeeId}/replace-secretary`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
